import headlines from 'ViatoUi/_exports/headlines.module.scss';
import paragraphs from 'ViatoUi/_exports/paragraphs.module.scss';
import roundings from 'ViatoUi/_exports/roundings.module.scss';
import shadows from 'ViatoUi/_exports/shadows.module.scss';
import sizes from 'ViatoUi/_exports/sizes.module.scss';
import types from 'ViatoUi/_exports/types.module.scss';

export default class Constants {
	static TYPES = Object.keys(types);

	static SIZES = Object.keys(sizes);

	static HEADLINES = Object.keys(headlines);

	static PARAGRAPHS = Object.keys(paragraphs);

	static SHADOWS = Object.keys(shadows);

	static ROUNDINGS = Object.keys(roundings);

	static PAGES = {
		CONTRACT_GENERATOR: '/contract-generator'
	};
}
